import { Theme, createStyles } from "@material-ui/core";

export const styles = ({ palette, typography, spacing }: Theme) => createStyles({
    actions: {
        alignItems: "flex-end",
        marginTop: "auto",
        paddingLeft: spacing.unit * 3
    },
    card: {
        maxWidth: 295,
        display: "flex",
        flexDirection: "column"
    },
    header: {
        position: "relative",
        "&::before": {
            content: `""`,
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgb(0,0,0)",
            opacity: 0.35
        }
    },
    content: {
        minHeight: 110
    },
    media: {
        height: 0,
        paddingTop: "53.25%"
    },
    more: {
        marginRight: "auto",
        marginBottom: spacing.unit,
        cursor: "pointer",
        textDecoration: "underline"
    },
    tag: {
        position: "absolute",
        bottom: spacing.unit * 2,
        right: spacing.unit * 2,
        backgroundColor: palette.primary.contrastText,
        color: palette.secondary.dark,
        fontSize: typography.caption.fontSize,
        fontWeight: typography.caption.fontWeight,
        letterSpacing: "0.05em",
        textTransform: "capitalize",
        borderRadius: 0,
        boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.1), 0 1px 1px 0 rgba(0, 0, 0, 0.07), 0 1px 0 -1px rgba(0, 0, 0, 0.06)"
    },
    title: {
        position: "absolute",
        top: spacing.unit * 2,
        left: spacing.unit * 2,
        maxWidth: 245,
        color: palette.primary.contrastText,
        fontWeight: 600
    },
    button : {
        margin: 0
    }
});


// WEBPACK FOOTER //
// ./src/components/Product/Product.style.tsx